import React from 'react';
import { Alert, Box, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { RATE_LIMIT_ERROR_MESSAGE } from 'src/utils/const';

const RateLimitAlert = ({
    handleOnSampleClick
}: {
    handleOnSampleClick?: (plan: string) => void;
}) => {

    return (
        <Box sx={{ width: '100%', height: '80px' }}>
            <Alert severity="warning">
                {RATE_LIMIT_ERROR_MESSAGE}
            </Alert>
        </Box>
    );
};

export default RateLimitAlert;